<!-- General content component for any report -->
<template>
  <v-col class="h-100 p-3 pt-0 d-flex flex-column">
    <div v-if="!shortView" class="subtitle-heading pb-1 my-1 d-flex align-center">
      <span v-if="subtitle">{{ getSubtitle }}</span>
      <slot name="subtitle-section" />
    </div>
    <div class="section-data h-100 w-100 d-flex justify-space-between">
      <slot name="data-section" />
    </div>
  </v-col>
</template>

<script setup>
import { computed } from 'vue';
import { useInternationalization } from '@/composables/use-internationalization';

const { tkey } = useInternationalization('reportingPage.sections');
const props = defineProps({
  // represents whether this report is open on (short) overview page
  shortView: {
    type: Boolean,
    required: false,
    default: false,
  },
  section: {
    type: String,
    required: true,
  },
  subtitle: {
    type: String,
    required: false,
    default: null,
  },
});

const getSubtitle = computed(() => {
  return props.subtitle || tkey(`${props.section}.subtitle`);
});
</script>

<style lang="scss" scoped>
@import '@style/base/_variables.scss';

.section-data {
  background: white;
  position: relative;
}

.subtitle-heading {
  border-bottom: 1px solid $reporting-section-divider;
  font-size: 1.2rem;
}
</style>
